<div class="flex h-full flex-col bg-lightergrey">
    @if (isLoading()) {
        <div
            class="flex h-screen items-center justify-center py-12 md:h-[90vh]">
            <app-loader color="#EE5769"></app-loader>
        </div>
    } @else {
        <div class="relative flex w-full flex-1 flex-col md:flex-row">
            <div
                class="relative hidden aspect-[3/1] overflow-hidden p-6 md:block md:h-full md:w-[30vh]">
                <app-lazy-picture
                    class="absolute inset-0 block h-full w-full"
                    [lazy]="true"
                    [configurations]="tripImageConfiguration()"
                    [alt]="nearestIncompleteTrip()?.name ?? ''"
                    [preload]="false">
                </app-lazy-picture>
            </div>

            <div
                class="relative flex max-h-screen flex-1 flex-col pl-6 md:h-[90vh] md:max-h-[90vh]">
                <div
                    class="absolute right-6 bottom-6 left-6 z-20 rounded-xl bg-white/80 p-4 shadow-floating-bar backdrop-blur-sm">
                    <div
                        class="flex flex-wrap items-center justify-center gap-2 md:justify-between">
                        <div>
                            @if (incompleteTravelerCount()) {
                                <div class="w-fit rounded-full px-4">
                                    <p class="text-sm font-bold text-darkred">
                                        {{ incompleteTravelerCount() }}
                                        {{
                                            incompleteTravelerCount() === 1
                                                ? 'traveler'
                                                : 'travelers'
                                        }}
                                        info needed!
                                    </p>
                                </div>
                            }
                        </div>
                        <app-cta-button
                            type="button"
                            (onClick)="onContinueToDashboard()"
                            variant="primary"
                            [disabled]="incompleteTravelerCount() > 0"
                            [additionalClasses]="[
                                'px-8',
                                'disabled:opacity-50',
                                'disabled:grayscale',
                            ]">
                            Continue to Dashboard
                        </app-cta-button>
                    </div>
                </div>
                <div class="flex-1 overflow-y-auto pt-6 pr-6 pb-32 md:pb-20">
                    <app-card-section>
                        <div
                            class="relative mb-4 aspect-[2/3] rounded-md md:hidden">
                            <app-lazy-picture
                                class="absolute inset-0 block h-full w-full"
                                [additionalClasses]="['rounded-md']"
                                [lazy]="true"
                                [configurations]="tripImageConfiguration()"
                                [alt]="nearestIncompleteTrip()?.name ?? ''"
                                [preload]="false">
                            </app-lazy-picture>
                        </div>
                        <h2 class="text-gray-900 text-2xl font-bold">
                            Thanks for booking with us!
                        </h2>
                        <p class="max-w-3xl text-deemphasized">
                            As a next step, it's important that you add your
                            fellow travellers to the trip so they can access all
                            the important trip information on their own trip
                            preparation dashboard
                        </p>
                    </app-card-section>
                    @if (fellowTravelers(); as travelers) {
                        <div class="space-y-8 pt-0 pb-6">
                            @for (
                                traveler of travelers;
                                track traveler.id;
                                let i = $index
                            ) {
                                <app-traveler-form
                                    [traveler]="
                                        getTravelerWithPosition(traveler, i + 1)
                                    "
                                    (travelerUpdated)="
                                        onTravelerUpdated($event)
                                    ">
                                </app-traveler-form>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    }
</div>
